import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    padding: '10px 15px',
    maxWidth: 1280,
    margin: '0 auto',
    '& dl, dd': {
      fontFamily: 'Poppins,Open Sans,sans-serif',
    },
  },
  tabs: {
    '& a': {
      minWidth: 110,
      textTransform: 'none',
    },
    '& a:hover': {
      backgroundColor: 'transparent !important',
      color: theme.palette.textColor.blue,
    },
    '& a.Mui-selected': {
      color: theme.palette.textColor.blue,
    },
    '& .MuiTabs-indicator': {
      backgroundColor: theme.palette.textColor.blue,
    },
    '& span': {
      fontSize: '0.875rem',
      fontWeight: 500,
    },
  },
  backButton: {
    height: 35,
    marginLeft: 40,
    marginRight: 'auto',
    color: 'black',
    whiteSpace: 'nowrap',
  },
}));
